import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import '../../../styles/HeaderInfo.css'
import { needsChrId } from '../../utility/needsChrId';

export default function HeaderInfo(props) {
    const activeOrInactiveColor = () => {
        let color = props.member.status !== 'Active' ? 'red' : 'green';
        return { backgroundColor: color };
    }
    return (
        <Container fluid>
            <Row>
                <Col className="d-flex justify-content-start">
                    <div
                        id="modal-member-status"
                        className="member-status"
                        style={activeOrInactiveColor()}
                    >
                        {props.member.status}
                    </div>
                    <div className="member-type">{props.member.passStatus.type}</div>
                    {props.member.passStatus.onHold &&
                        <div
                        id="modal-member-on-hold"
                            className="member-on-hold"> On Hold
                        </div>}
                </Col>
                <Col className="d-flex justify-content-end">
                {needsChrId(props.member) &&
                        <div
                        id="modal-member-chr-needed"
                            className="member-status"
                        style={{
                            backgroundColor: 'red'
                            , color: 'white'
                        }}
                >Missing CHR User ID</div>
                }
                </Col>
            </Row>
        </Container>
    )
}